export default {
  "finishAuthority": "Only the round scorer can finish this round.",
  "finishDraft": "Confirm or reset draft scores before finishing.",
  "finishScoreRetry": "Scores have not saved. Check your connection and retry.",
  "finishSavingScores": "Waiting for score saves to be acknowledged.",
  "finishStatsRetry": "Resolve or retry unsaved stats in Hole view.",
  "finishSavingStats": "Waiting for your stats to finish saving.",
  "finishMissingScores": "Every player needs a confirmed score on every hole.",
  "finishingRound": "Finishing…",
  "holeSaveError": "Your viewing position could not be saved. Scores are saved separately.",

  "scorecardHeading": "Scorecard",
  "playersScored": "{count} of {total} players scored",
  "yourScorecard": "Your scorecard",
  "roundView": "Round view",
  "scoreCoverageShort": "{count} of {total} comparable rounds",
  "offline": "Offline — waiting to save",
  "noPutts": "No putts recorded yet",
  "excludedReasons": "Excluded in this window: {scores} rounds with incomplete scores; {par} rounds with missing historical par.",
  "playVideo": "Play hole {number} video",
  "pauseVideo": "Pause hole {number} video",
  "puttChoice": "{count} putts",
  "exactPutts": "Exact putt count",
  "apply": "Apply",
  "cancel": "Cancel",
  "tapToClear": "Tap a selected answer to clear.",
  "personal": "My scorecard",
  "group": "Group",
  "cardView": "Scorecard view",
  "unrecorded": "Unrecorded",
  "strokes": "strokes recorded",
  "scoredCoverage": "{count} of {total} holes scored",
  "parCoverage": "{count} holes with reliable par",
  "legend": "Scorecard help",
  "legendHelp": "FW: fairway. GIR: green in regulation. ✓ Hit / Yes; × Missed / No; — unrecorded; N/A inapplicable. Tap a hole number to return to scoring.",
  "hole": "Hole",
  "par": "Par",
  "score": "Score",
  "goHole": "Go to hole {number}",
  "recordedStrokes": "Recorded strokes",
  "continueHole": "Continue at hole {number}",
  "draft": "Draft",
  "holePosition": "{number} / {total}",
  "holeNumber": "Hole {number}",
  "strokeIndex": "SI",
  "metres": "m",
  "yards": "yd",
  "card": "Card",
  "finishRound": "Finish round",
  "swipeCard": "Swipeable hole scorecard",
  "holeNavigation": "Hole navigation",
  "previousHole": "Previous hole",
  "nextHole": "Next hole",
  "reviewCard": "Review card",
  "guest": "Guest",
  "scorer": "Scorer",
  "member": "Member",
  "toPar": "to par",
  "reset": "Reset",
  "confirmScore": "Confirm {score}",
  "decreaseScore": "Decrease {name} score",
  "increaseScore": "Increase {name} score",
  "confirmPlayerScore": "Confirm score {score} for {name}",
  "draftScore": "Draft score {score}",
  "savedScore": "Saved score {score}",
  "keepingCard": "{name} is keeping this scorecard.",
  "scoringTrend": "Scoring trend",
  "viewData": "View data",
  "roundsLogged": "Rounds logged",
  "recentRounds": "Recent rounds",
  "firstTitle": "Your progress starts with a round",
  "firstHelp": "Complete a round to follow your scores. Optional stats help you understand your game.",
  "startRound": "Start a round",
  "puttingHelp": "Count your strokes on the green.",
  "fairwayHelp": "Record whether your tee shot finds the fairway on par 4 and 5 holes.",
  "noMatch": "No rounds match these filters",
  "noMatchHelp": "Choose another course, tee or hole count to see your rounds.",
  "resetFilters": "Reset filters",
  "benchmark": "Your first benchmark",
  "benchmarkHelp": "Another comparable round will begin a trend.",
  "whyOne": "Why only one round?",
  "excludedHelp": "{count} other rounds in this window lack complete scores or reliable historical par.",
  "historicalHelp": "Your rounds are here. Record scores and optional stats in future rounds to build your progress.",
  "noScoring": "No comparable scoring rounds yet",
  "puttingTab": "Putting",
  "fairwaysTab": "Fairways",
  "greensTab": "GIR",
  "perHole": "putts / recorded hole",
  "coverage": "Recorded coverage",
  "loggedCoverage": "{count} completed in this window",
  "viewRounds": "View rounds",
  "roundUnavailable": "This round is unavailable.",
  "returnGolf": "Return to Golf",
  "loadingCard": "Loading your scorecard",
  "restoringCard": "Restoring your current hole and scores",
  "completeError": "Every player needs a score on every hole before the round can finish.",
  "stablefordNote": "Gross scoring · Stableford points pending authoritative playing handicaps",
  "missingImage": "Hole preview unavailable",
  "roundComplete": "Round complete",

  "checkingLatest": "Checking latest saved values…",
  "conflictTitle": "Review changed stats",
  "conflictHelp": "Stats changed elsewhere. Review the latest values and your draft.",
  "latestSaved": "Latest saved",
  "yourDraft": "Your unsaved draft",
  "editedFieldsOnly": "Only your edited fields will be saved.",
  "useLatest": "Use latest values",
  "confirmReviewed": "Save reviewed changes",
  "holeCount": "{count} holes",
  "evenPar": "Even par",

  "score_changed_reload": "This score changed elsewhere. The latest saved score is shown; your value is retained as a draft. Review and confirm it again.",
  "putts_exceed_score": "The score is lower than recorded putts. Adjust the score or ask the golfer to review their putts.",
  "answersRecorded": "{hits} of {count} recorded",
  "partialPutts": "{total} putts across {count} of {holes} holes recorded",
  "scoreSaveError": "This score could not be saved. Your score is retained. Check your connection and retry.",
  "title": "My hole stats",
  "optional": "Optional",
  "support": "Add as much or as little as you like",
  "putts": "Putts",
  "fairway": "Fairway",
  "gir": "Green in regulation",
  "girHelp": "Reaching the putting green in no more than par minus two strokes.",
  "yes": "Yes",
  "no": "No",
  "hit": "Hit",
  "missed": "Missed",
  "clear": "Clear",
  "clearAll": "Clear stats",
  "unknownPar": "Historical par unavailable; this answer cannot be recorded.",
  "na": "N/A",
  "increase": "Increase putts",
  "decrease": "Decrease putts",
  "retry": "Retry",
  "saved": "Saved",
  "saving": "Saving…",
  "unsaved": "Unsaved",
  "saveError": "Stats could not be saved. Your changes are still here.",
  "progress": "My golf progress",
  "entrySubtitle": "Rounds, stats and improvement",
  "subtitle": "Your game, over time",
  "back": "Back",
  "courseTee": "Course / tees",
  "holes": "Holes",
  "period": "Period",
  "lastRounds": "Last {count} rounds",
  "allTime": "All time",
  "overview": "Overview",
  "trends": "Trends",
  "rounds": "Rounds",
  "scoreToPar": "Score to par",
  "average": "Average to par",
  "best": "Best round",
  "roundStats": "Your round stats",
  "viewTrends": "View trends",
  "putting": "Putts per hole",
  "fairways": "Fairways hit",
  "greens": "Greens in regulation",
  "lower": "Lower is better",
  "higher": "Higher is better",
  "par45": "Par 4 & 5",
  "recordedOnly": "Only recorded stats are included. Skipped entries are excluded.",
  "holesRecorded": "{count} holes recorded",
  "roundCoverage": "{count} completed rounds · {holes} holes in scope",
  "scoreCoverage": "{count} of {total} rounds with complete gross scores and reliable historical par.",
  "noMetric": "No recorded measurements in this scope.",
  "oneRound": "One recorded round. More rounds will show a trend.",
  "noHistory": "No completed rounds available",
  "emptyHelp": "Complete a round or choose another filter to see your progress.",
  "window": "All-time history, analysed in pages of up to 200 rounds. Values and charts describe the current page.",
  "loading": "Loading your progress…",
  "loadError": "We couldn’t load your progress.",
  "chartDescription": "Chronological rounds. Missing entries are excluded. Open chart data for dates, values and recorded coverage.",
  "chartData": "Chart data: dates, values and coverage",
  "date": "Date",
  "value": "Value",
  "recorded": "Recorded holes",
  "pagination": "Round history pages",
  "previous": "Previous",
  "next": "Next",
  "errors": {
    "invalid_putts": "Enter a whole number of putts from 0 to 30.",
    "putts_exceed_score": "Putts cannot exceed the saved gross score. Adjust putts or the score and retry.",
    "fairway_not_applicable": "Fairways can only be recorded on par 4 and par 5 holes.",
    "par_unavailable": "Historical par is unavailable for this hole.",
    "stats_changed_reload": "These stats changed in another request. Review your entries before retrying.",
    "round_not_editable": "This round is no longer editable. Your changes have not been saved."
  }
}
